import { getMotionEvents } from "../../API/apiDevices";

export class MotionEventsHandler {
  public static async getMotionEvents(
    startDateISOStr: string,
    endDateISOStr: string,
    serialNumber: string
  ) {
    if (startDateISOStr === null || startDateISOStr === "") {
      console.log("Invalid start datetime");
    }
    const response = await getMotionEvents(serialNumber, startDateISOStr, endDateISOStr);
    return response.data;
  }
}
